export enum SUSCRIPCION_TYPES {
  SUSCRIPCION_SET_DATOS_SUSCRIPCION = 'SUSCRIPCION_SET_DATOS_SUSCRIPCION',
  SUSCRIPCION_SET_SUSCRIPCIONES = 'SUSCRIPCION_SET_SUSCRIPCIONES',
  SUSCRIPCION_SET_SUSCRIPCIONES_FILTRADAS = 'SUSCRIPCION_SET_SUSCRIPCIONES_FILTRADAS',
  SUSCRIPCION_SET_SELECCION = 'SUSCRIPCION_SET_SELECCION',
  SUSCRIPCION_SET_DETALLE_PAGO = 'SUSCRIPCION_SET_DETALLE_PAGO',
  SUSCRIPCION_SET_VALIDAR_SALDO = 'SUSCRIPCION_SET_VALIDAR_SALDO',
  SUSCRIPCION_CLEAR = 'SUSCRIPCION_CLEAR',
}
